import React from 'react';

function Rodape() {
    return (
        <footer class="bg-light py-5">
            <div class="container">
                <div class="small text-center text-muted">
                    <a href="/termo">Termo de condições de uso e Política de privacidade</a>
                </div>
                <div class="small text-center text-muted">Copyright &copy; 2019 - isBrito</div>
                <div class="small text-center text-muted">CNPJ: 33.102.650/0001-05</div>
                <div class="small text-center text-muted">
                    <a href="https://api.whatsapp.com/send?phone=5586981817123&text=Olá%20desejo%20um%20atendimento%20personalizado">(86) 9 8181-7123</a>
                    <div>contato@expertserv.net</div>
                </div>
            </div>
        </footer>
    );
}

export default Rodape;